// useLoadDrift.tsx
import { useState, useEffect } from "react";
import { UsersScope, UserResource } from "@gocardless/api/dashboard/types";

import { loadDriftScript } from "./client/drift";

import { getConfig } from "src/common/config";

export const useLoadDrift = (user: UserResource | undefined) => {
  const [isDriftLoaded, setIsDriftLoaded] = useState(false);
  const writeKey = getConfig().client.segment.key;
  const driftAppId = getConfig().client.drift.appId;
  const isSafeToLoad = window && user?.scope === UsersScope.Admin;

  useEffect(() => {
    if (isSafeToLoad && !window.drift && driftAppId) {
      loadDriftScript(writeKey);
      setIsDriftLoaded(true);
    }
  }, [driftAppId, isSafeToLoad, writeKey]);

  return { isDriftLoaded };
};
